exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".speakerContainer {\n    max-width: 60vw;\n}\n\n.jumbotron {\n\tpadding: 1em 2em 4em 2em !important;\n}\n\n.cursor-pointer {\n    cursor: pointer;\n    font-size: 2em;\n}\n\n@media only screen and (max-width:768px) {\n    .speakerContainer {\n        max-width: 80vw;\n        margin: 0 -10vw;\n    }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/src/app/summary/summary.component.css
// module id = ../../../../../src/app/summary/summary.component.css
// module chunks = 0